export default {
  adapters: {
    breadcrumbs: {
      editorial: {
        home: 'Home'
      },
      ugr: {
        home: 'Home'
      },
      recipes: {
        home: 'Recipes'
      }
    },
    cards: {
      userCollection: {
        savedItemDescription_one: 'item',
        savedItemDescription_few: 'items',
        savedItemDescription_many: 'items',
        savedItemDescription_other: 'items',
        savedItemDescription: 'item',
        savedItemDescription_plural: 'items'
      },
      userRecipe: {
        statusTextDraft: 'Draft recipe',
        statusApproved: 'Member recipe',
        statusPending: 'Awaiting approval',
        statusRejected: 'Recipe denied'
      }
    },
    iconAdapter: {
      formatTimeHours_one: '{{hours}} hr',
      formatTimeHours_other: '{{hours}} hrs',
      formatTimeHours: '{{hours}} hr',
      formatTimeHours_plural: '{{hours}} hrs',
      formatTimeMins_one: '{{minutes}} min',
      formatTimeMins_other: '{{minutes}} mins',
      formatTimeMins: '{{minutes}} min',
      formatTimeMins_plural: '{{minutes}} mins'
    },
    pageSchema: {
      editorial: {
        recipe: {
          calories: '{{calories}} calories',
          carbContent: '{{carbs}} grams carbohydrates',
          fatContent: '{{fat}} grams fat',
          fibreContent: '{{fibre}} grams fiber',
          proteinContent: '{{protein}} grams protein',
          satFatContent: '{{saturates}} grams saturated fat',
          sodiumContent: '{{sodium}} milligram of sodium',
          sugarContent: '{{sugars}} grams sugar'
        }
      },
      ugr: {
        servesDefault: 'Serves'
      }
    },
    post: {
      ugr: {
        messageMember: 'Member recipe',
        messageOther: '{{status}} recipe',
        statuses: {
          draft: 'draft',
          approved: 'approved',
          rejected: 'rejected',
          pending: 'pending',
          published: 'published'
        }
      }
    },
    posts: {
      editorial: {
        liveBlog: {
          hour_one: 'hour ago',
          hour_few: 'hours ago',
          hour_many: 'hours ago',
          hour_other: 'hours ago',
          hour: 'hour ago',
          hour_plural: 'hours ago',
          lessThanHour_one: 'minute ago',
          lessThanHour_few: 'minutes ago',
          lessThanHour_many: 'minutes ago',
          lessThanHour_other: 'minutes ago',
          lessThanHour: 'minute ago',
          lessThanHour_plural: 'minutes ago',
          lessThanMinute: 'less than 1 minute ago',
          updatedMessageLive: 'LIVE updated',
          updatedMessageNotLive: 'Updated'
        }
      },
      postAdapter: {
        callout: 'This is a {{status}} {{entity}}',
        recommendedTitle: 'More like this',
        statuses: {
          draft: 'draft',
          approved: 'approved',
          rejected: 'rejected',
          pending: 'pending',
          published: 'published'
        },
        entities: {
          glossary: 'glossary',
          howTo: 'how to',
          editorialList: 'editorial list',
          plant: 'plant',
          post: 'post',
          recipe: 'recipe',
          review: 'review',
          'broadcast-show': 'broadcast show',
          venue: 'venue',
          page: 'page',
          'user-collection': 'user collection',
          blog: 'blog'
        }
      },
      recipeAdapter: {
        getPublicationMessage: 'Recipe from',
        nutritionHighInPrefix: 'high in',
        nutritionLabel: 'Nutrition',
        nutritionLowInPrefix: 'low in',
        recommendedAltTitle: 'Our Most Popular Alternative',
        servingsLabel: 'Serves'
      },
      userRecipeAdapter: {
        categoryDisplay: 'Recipes'
      }
    }
  }
};